import React, { useEffect, useState ,useContext} from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import classes from "../../Loans/loans.module.css";
import { Box, Card, CardContent, Grid, Typography, Stack, Button } from "@mui/material";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { postApiData } from "../../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../../components/utilities/nodeApiList";
import AutocompleteForm from "../../../../../components/common/autuCompleteForm";
import Loader from "../../../../../components/common/loader";
import { ConnContext } from "../../../../../context/ConContext";
import SweetAlertPopup from "../../../../../components/common/sweetAlertPopup";
import { compareIdAndReturnObject } from "../../../../../components/common/commonArray";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import Eye from "./Eye.svg"
import Disbursement from "./Disbursement.svg"
import Repayment from "./Repayment.svg"
import Finance_app from "./Finance_app.svg"
import { numberCommaFormat } from "../../../../../components/utilities/fileUploadHelper";


// const defaultFormData = {
//   custNo: "",
// };
const LoanTable = ({ accList }) => {

  const { useFormData, defaultFormData, setLoanAccounts, loanAccounts, setCustNoContext, custNoContext } = useContext(ConnContext);
  const {
    control,
    handleSubmit,
    setValue,
    register,
    getValues,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useFormData;

  const [isLoading, setIsloading] = useState(false);
  // const [loanAccounts, setLoanAccounts] = useState([]);
  const [custNo, setCustNo] = useState([]);
  const navigate = useNavigate()

  const { loading, error, isAuthenticated, user } = useSelector(
    (state) => state.auth
  );

  console.log("user", user)

  const columns = [

    {
      name: "View",
      label: "View",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ style: { width: '100px' } }),
        customBodyRender: (value, { rowData, rowIndex }, tableMeta) => {
          // return (
          //   <Button
          //     onClick={() => navigate("/loans/loandetails", { state: loanAccounts[rowIndex] })}
          //   ><VisibilityIcon />
          //   </Button>
          // );
          return (
            <img src={Eye}
              alt="Eye Icon"
              onClick={() => navigate("/account/loandetails", { state: loanAccounts[rowIndex] })}
              style={{ cursor: 'pointer' }}
              title="View Loan Details"
            />
          );
        },
      },
    },

    {
      name: "loanAccNo",
      label: "Loan Account no.",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "loanAmount",
      label: "Loan Amount",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, { rowData, rowIndex }, tableMeta) => {
          const style = {
            display: "flex",
            justifyContent: "flex-end"
          };

          return (
            <div style={style}>
               {numberCommaFormat(value)}
            </div>
          );
        },
      },
    },
    {
      name: "balance",
      label: "Balance",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, { rowData, rowIndex }, tableMeta) => {
          const style = {
            display: "flex",
            justifyContent: "flex-end"
          };

          return (
            <div style={style}>
               {numberCommaFormat(value)}
            </div>
          );
        },
      },
    },
    {
      name: "EMI",
      label: "EMI",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, { rowData, rowIndex }, tableMeta) => {
          const style = {
            display: "flex",
            justifyContent: "flex-end"
          };

          return (
            <div style={style}>
              ₹ {value}
            </div>
          );
        },
      },
    },
    {
      name: "interestRate",
      label: "Interest Rate (%)",
      options: {
        filter: true,
        sort: false,

      },
    },


  ];

  const options = {
    textLabels: {
      body: {
        noMatch: (
          <div
            style={{
              display: "flex",
              flexDirection: 'column',
              height: "30vh",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "larger",
            }}
          >
            {/* <img src={NoData} alt="no" /> */}
            <svg width="125" height="149" viewBox="0 0 125 149" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M34.0221 132.434C33.4829 135.11 35.5946 137.116 36.7177 137.785L42.5 135L38.0659 130.428L34.0221 132.434Z" stroke="#042879" />
              <path d="M99.5639 127.991H39.2383V82.7697H99.5007L99.5639 127.991Z" fill="white" stroke="#042879" />
              <path d="M36.044 142.467C36.044 141.397 36.4933 139.123 36.7179 137.785C33.3484 136.447 34.0223 132.434 33.3484 132.434C32.6744 132.434 27.957 133.103 27.957 135.109C27.957 137.116 34.0223 147.149 36.7179 147.818C39.4136 148.487 40.0875 147.149 39.4136 146.48C38.9371 146.007 36.044 143.805 36.044 142.467Z" stroke="#042879" />
              <path d="M57.5811 76.5178L113.357 76.5179L99.9558 82.9158L41.6568 81.8237L57.5811 76.5178Z" fill="#042879" stroke="#042879" stroke-linejoin="round" />
              <path d="M115.5 119.411L100.5 127.655V83.3368L115.5 77.2431V119.411ZM14.4997 98.6331L12.8121 103.1L10.1756 102.577C10.0889 102.161 10.0029 101.606 9.97349 101.039C9.93502 100.297 9.99938 99.6283 10.2071 99.216C10.5965 98.4431 11.0059 97.8738 11.2624 97.5621L14.4997 98.6331Z" fill="white" stroke="#042879" />
              <path d="M3.02175 110.362C4.10001 109.292 7.9638 105.011 9.76091 103.004C8.41307 99.6602 11.1087 96.9847 11.1087 96.9847C11.1087 96.9847 6.39133 94.9781 5.71741 94.9781C5.0435 94.9781 1 107.686 1 109.693C1 111.7 1.67392 111.7 3.02175 110.362Z" stroke="#042879" />
              <path d="M101.266 83.1942L115.37 76.6126L124.249 86.8481L110.62 95.8222L101.266 83.1942Z" fill="white" stroke="#042879" />
              <path d="M62.3765 98.6163C62.3765 98.6164 62.3746 98.6176 62.3708 98.6196C62.3746 98.6171 62.3764 98.6162 62.3765 98.6163ZM89.031 68.5944C93.5499 72.6858 96.6116 78.271 97.4462 82.4383L89.3677 82.4384C89.3023 82.409 89.2141 82.3529 89.0745 82.2481C89.0403 82.2224 89.0031 82.1939 88.9631 82.1633C88.8154 82.05 88.6305 81.9082 88.4208 81.7751C87.8585 81.4182 87.0924 81.1008 85.9116 81.1008C85.5466 81.1008 85.2556 81.3045 85.0431 81.5293C84.8266 81.7582 84.6326 82.0692 84.4548 82.4249C84.0976 83.1396 83.7531 84.1429 83.419 85.3324C82.7488 87.7185 82.0925 90.9573 81.4606 94.3857C81.1069 96.305 80.758 98.2996 80.4182 100.243C80.1522 101.764 79.8917 103.253 79.6387 104.65C79.0585 107.854 78.5156 110.584 78.0199 112.224C77.7986 112.956 77.2031 113.883 76.2588 114.969C75.3235 116.044 74.082 117.234 72.6231 118.49C69.7059 121.001 65.9538 123.748 62.1287 126.334C58.3054 128.92 54.4187 131.339 51.2374 133.193C49.6466 134.121 48.2348 134.906 47.0973 135.5C46.155 135.991 45.4193 136.342 44.9302 136.536C42.8879 134.483 39.3665 130.621 37.4852 128.53C43.7099 124.639 55.6284 117.175 57.2091 116.129C57.5714 115.89 57.8941 115.427 58.1828 114.906C58.4835 114.362 58.7902 113.673 59.0943 112.895C59.7031 111.337 60.319 109.375 60.8687 107.402C61.4189 105.428 61.9057 103.433 62.2553 101.803C62.4301 100.988 62.5713 100.261 62.6691 99.6726C62.765 99.095 62.8246 98.619 62.8246 98.3223C62.8246 98.2311 62.8149 98.0696 62.7206 97.9198C62.6672 97.8348 62.5858 97.753 62.4725 97.7011C62.3614 97.6502 62.2526 97.6429 62.1656 97.6521C62.0094 97.6686 61.8845 97.7418 61.8125 97.7898C61.7296 97.845 61.6485 97.9139 61.5722 97.9858C61.2749 98.2662 60.8749 98.7616 60.4186 99.3706C59.6678 100.373 58.7003 101.771 57.6654 103.266C57.4278 103.609 57.1866 103.958 56.9437 104.308C55.6371 106.19 54.2768 108.121 53.1193 109.581C52.5394 110.312 52.0213 110.91 51.5938 111.322C51.3795 111.529 51.2002 111.676 51.0574 111.769C50.9223 111.857 50.8633 111.867 50.8635 111.868C50.8635 111.868 50.865 111.868 50.868 111.868C50.646 111.868 49.9184 111.809 48.7698 111.697C47.6367 111.586 46.1252 111.427 44.3623 111.234C40.8369 110.847 36.3108 110.325 31.8055 109.782C27.2998 109.238 22.817 108.674 19.3774 108.205C17.6572 107.97 16.2009 107.759 15.1343 107.586C14.6004 107.499 14.1686 107.423 13.8518 107.359C13.693 107.327 13.568 107.299 13.4757 107.275C13.4505 107.268 13.4298 107.262 13.4129 107.257C13.4075 107.233 13.4018 107.198 13.3977 107.149C13.3815 106.955 13.403 106.663 13.4716 106.272C13.6076 105.497 13.9054 104.455 14.2936 103.297C15.0194 101.13 16.0368 98.6268 16.8062 96.859C20.2907 97.3021 25.4115 97.9099 29.9109 98.3517C32.2412 98.5804 34.4101 98.7652 36.1004 98.8591C36.9449 98.906 37.6765 98.9307 38.252 98.9262C38.8003 98.922 39.2798 98.8924 39.5685 98.7969C39.777 98.728 39.9812 98.5945 40.1692 98.4453C40.3636 98.2911 40.572 98.0946 40.7897 97.8676C41.2254 97.4133 41.7252 96.809 42.262 96.1074C43.3369 94.7025 44.5875 92.8718 45.8118 90.9863C48.2576 87.2195 50.6281 83.1882 51.3145 81.8257C51.3759 81.7039 51.4442 81.5656 51.5199 81.4122C53.1013 78.2093 57.9356 68.4183 71.2433 64.0162C78.093 61.7504 84.3128 64.3226 89.031 68.5944ZM13.4271 107.303C13.4271 107.303 13.4263 107.302 13.425 107.299C13.4265 107.302 13.4272 107.303 13.4271 107.303Z" fill="white" stroke="#042879" />
              <path d="M54 76.5C59.8406 80.7361 68.4999 90.8574 84 83.5" stroke="#042879" />
              <ellipse cx="79.1739" cy="32.7739" rx="15.5001" ry="15.3837" fill="#FFE4E5" />
              <path d="M44.3047 38.1254C44.3047 41.9091 41.2131 44.9828 37.3916 44.9828C33.57 44.9828 30.4785 41.9091 30.4785 38.1254C30.4785 34.3417 33.57 31.2679 37.3916 31.2679C41.2131 31.2679 44.3047 34.3417 44.3047 38.1254Z" stroke="#ED3237" />
              <ellipse cx="53.5654" cy="7.35744" rx="7.41307" ry="7.35744" fill="#FFE4E5" />
              <path d="M115.74 45.4826C115.74 48.1581 113.553 50.3334 110.848 50.3334C108.143 50.3334 105.957 48.1581 105.957 45.4826C105.957 42.8071 108.143 40.6317 110.848 40.6317C113.553 40.6317 115.74 42.8071 115.74 45.4826Z" stroke="#ED3237" />
              <path d="M79.08 27.704C80.136 27.704 80.9893 28.0027 81.64 28.6C82.2907 29.1973 82.616 29.9973 82.616 31C82.616 32.12 82.2693 32.952 81.576 33.496C80.8827 34.0293 79.944 34.296 78.76 34.296L78.712 35.816H77.448L77.384 33.288H77.848C78.904 33.288 79.7307 33.128 80.328 32.808C80.9253 32.488 81.224 31.8853 81.224 31C81.224 30.36 81.032 29.8533 80.648 29.48C80.264 29.1067 79.7467 28.92 79.096 28.92C78.4347 28.92 77.912 29.1013 77.528 29.464C77.1547 29.816 76.968 30.3013 76.968 30.92H75.592C75.592 30.28 75.736 29.72 76.024 29.24C76.312 28.7493 76.7173 28.3707 77.24 28.104C77.7733 27.8373 78.3867 27.704 79.08 27.704ZM78.072 39.096C77.7947 39.096 77.56 39 77.368 38.808C77.176 38.616 77.08 38.3813 77.08 38.104C77.08 37.8267 77.176 37.592 77.368 37.4C77.56 37.208 77.7947 37.112 78.072 37.112C78.3387 37.112 78.5627 37.208 78.744 37.4C78.936 37.592 79.032 37.8267 79.032 38.104C79.032 38.3813 78.936 38.616 78.744 38.808C78.5627 39 78.3387 39.096 78.072 39.096Z" fill="#042879" />
            </svg>

            <div style={{ fontSize: '15px' }}> Sorry, no matching records found.</div>
          </div>
        ),
      },
    },
    filterType: "dropdown",
    responsive: "stacked",
    filter: true,
    download: false,
    print: false,
    // checkbox:true,
    selectableRows: false,
    pagination: false,
    // customFooter: () => {
    //   return (
    //     <GridTablePagination
    //       currentPage={currentPage}
    //       totalCount={totalRecord}
    //       pageSize={goPageNumber}
    //       control={control}
    //       onPageChange={(page) => {
    //         getDeposit(page);
    //       }}
    //     />
    //   );
    // },
  };


  // useEffect(() => {
  //   if (user)
  //     handleCustomerFetch()
  // }, []);

  const handleCustomerFetch = async () => {
    try {
      setIsloading(true);
      let payload = {
        username: user?.userId,
        sessionId: user?.sessionId,
      };
      const response = await postApiData(apiList.CORPORATE_CUSTOMER, payload);
      console.log("addhar", response);
      if (response?.status === true) {
        setCustNo(response?.data?.custDetails);
        setIsloading(false);
      } else {
        SweetAlertPopup(response?.message, "Error", "error");
        setIsloading(false);
      }
    } catch (err) {
      console.log(err);
      setIsloading(false);
    }
  };

  // const CustDetails =
  //   user?.customerList &&
  //   user?.customerList.map((cust) => ({
  //     code: cust.customerNo,
  //     value: cust.customerName.trim() + " - " + cust.customerNo,
  //   }));

  // useEffect(() => {
  //   setValue("custNo", compareIdAndReturnObject(user?.customerList, user?.customerList[0]?.code));
  // }, [user?.customerList]);
  
  // useEffect(() => {
  //   if (user?.customerList?.length > 0) {
  //     setValue("custNo", compareIdAndReturnObject(user?.customerList, user?.customerList[0]?.code))
  //   }
  // }, [user]);


 
  useEffect(() => {
    if (watch("custNo") != custNoContext) {
      handleLoanAccountFetch();
      setCustNoContext(watch("custNo"))
    }
  }, [watch("custNo")]);


  const handleLoanAccountFetch = async () => {
    try {
      setIsloading(true);
      let payload = {
        username: user?.userId,
        sessionId: user?.sessionId,
        custNo: watch("custNo")?.code,
      };
      const response = await postApiData(
        apiList.CORPORATE_LOANACCOUNT,
        payload
      );
      if (response?.status === true) {
        setLoanAccounts(response?.data?.loanDeatils);
        setIsloading(false);
      } else {
        SweetAlertPopup(response?.message, "Error", "error");
        setLoanAccounts([]);
        // setApiData([]);
        // setValue("loanAcc", "")
        setIsloading(false);
      }
    } catch (err) {
      console.log(err);
      setIsloading(false);
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: " #DAE2F6",
      color: "#323232",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      {isLoading ? (<Loader loading={true} />) : (<Loader loading={false} />)}
      <Box className={classes.tableMainBox} component="form"
      >
        {/* <Box
          className={classes.mainContainer}
          component="form"
          style={{paddingBottom : "20px"}}
          // onSubmit={handleSubmit(onSubmit)}
        > */}
        <Grid
          container
          // columnSpacing={2}
          // rowSpacing={2}
          style={{ paddingRight: "2vw" }}
        >
          <Grid item xs={12} sm={6} md={8} style={{ paddingBottom: "2vw" }}></Grid>

          <Grid item xs={12} sm={6} md={4} style={{ paddingBottom: "2vw" }}>
            <div className={classes.frowdataaff}>
              <div className={classes.frowtextaff}>
                Customer Name/No.<sup className={classes.required}>*</sup>
              </div>
              <div className={classes.frow1aff}>
                <AutocompleteForm
                  controlerProps={{
                    control: control,
                    name: "custNo",
                  }}
                  TextFieldProps={{
                    placeholder: "Select Customer No.",
                    onKeyDown: (event) => {
                      //const regex = /^[a-zA-Z]*$/;
                      const regex = /^[a-zA-Z \s]*$/;
                      const isBackspace = event.keyCode === 8;
                      const isValidInput = regex.test(event.key);

                      if (!isValidInput && !isBackspace) {
                        event.preventDefault();
                      }
                    },
                  }}
                  rules={{
                    required:
                      "Customer Name/No. " +
                      errorMessages.error_autocomplete_message,
                  }}
                  data={user?.customerList}
                  required={true}
                />
              </div>
            </div>
          </Grid>
        </Grid>
        {/* </Box> */}
        {/* <TableContainer component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow style={{ textAlign: "center" }}>
                <StyledTableCell>Loan Account No.</StyledTableCell>
                <StyledTableCell>Account Name</StyledTableCell>
                <StyledTableCell>Account Status</StyledTableCell>
                <StyledTableCell>Balance</StyledTableCell>
                <StyledTableCell>Loan Account Type</StyledTableCell>
              </TableRow>
            </TableHead>

         
              <TableBody>
    
              {
                loanAccounts?  loanAccounts?.map((row , index) => <>
                 <StyledTableRow key={index}>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {row.loanAccNo}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.accHolderName}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.accStatus}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.balance}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.accType}
                      </StyledTableCell>
                    </StyledTableRow>
                </>):<div className={classes.nodata}>No data avaliable</div>
              }
              
             
             
            
            </TableBody>
          </Table>
        </TableContainer> */}

        <div className={classes.Sbox2}>
          <div style={{ width: "100%", marginBottom: "10px" }}>
            <MUIDataTable
              title={"Loan Account Summary"}
              data={loanAccounts ? loanAccounts :[]}
              columns={columns}
              options={options}
            />
          </div>
        </div>
      </Box>
    </>
  );
};

export default LoanTable;
